'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var objectSpread2 = require('./../../external/@babel/runtime/helpers/esm/objectSpread2.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../external/classnames/index.js');
var Banner = require('../Banner/Banner.js');
var SecondaryNavItem = require('./SecondaryNavItem/SecondaryNavItem.js');
var slugify = require('../../utilities/slugify.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SecondaryNav = function SecondaryNav(_ref) {
  var active = _ref.active,
    banner = _ref.banner,
    navItems = _ref.navItems,
    className = _ref.className;
  var navClasses = index.default(className, 'secondary-nav');
  return /*#__PURE__*/React__default.default.createElement(Banner.Banner, banner, navItems.length > 0 && /*#__PURE__*/React__default.default.createElement("nav", {
    className: navClasses
  }, /*#__PURE__*/React__default.default.createElement("ul", null, navItems.map(function (_ref2) {
    var name = _ref2.name,
      link = _ref2.link,
      openNewTab = _ref2.openNewTab;
    return /*#__PURE__*/React__default.default.createElement(SecondaryNavItem.SecondaryNavItem, {
      key: "secondary-nav-item-".concat(slugify.slugify(name)),
      linkText: name,
      link: link,
      openNewTab: openNewTab,
      active: name === active
    });
  }))));
};
SecondaryNav.defaultProps = {
  className: ''
};
SecondaryNav.propTypes = {
  active: PropTypes__default.default.string.isRequired,
  banner: PropTypes__default.default.shape(objectSpread2.default({}, Banner.Banner.propTypes)).isRequired,
  navItems: PropTypes__default.default.arrayOf(PropTypes__default.default.shape({
    link: PropTypes__default.default.string.isRequired,
    name: PropTypes__default.default.string.isRequired,
    openNewTab: PropTypes__default.default.bool
  })).isRequired,
  className: PropTypes__default.default.string
};

exports.SecondaryNav = SecondaryNav;
exports.default = SecondaryNav;
//# sourceMappingURL=SecondaryNav.js.map
